// extracted by mini-css-extract-plugin
export default {"wrap":"SelectTextQuestion_wrap__yashg","row":"SelectTextQuestion_row__ppd4A","select":"SelectTextQuestion_select__OmDMN","input":"SelectTextQuestion_input__SODH3"};